import React, { useState } from "react";
import WeatherDisplay from "./WeatherDisplay";
import Control from "react-leaflet-control";
import FutureMonths from "./FutureMonths";
import "./DayPicker.scss";
import PickContainer from "./PickContainer";
import arrowRight from "../../Icons/arrowRight.svg";
import moment from "moment";

const labels = {
  later: {
    da: "Senere",
    en: "Later",
    de: "Bis",
  },
};
/**
 * A day picker for the weather forecast
 */
const DayPicker = (props: {
  display: boolean;
  setSmallWeather: (arg0: boolean) => void;
  setFutureMode: (fMode: boolean, fDate: moment.Moment | false) => void;
  onChangeTime: (day: moment.Moment, hours: number) => Promise<void>;
  weather: any;
  spotName?: string | null;
  weatherLoading: boolean;
  language: string;
}) => {
  const [showWhenSmall, setShowWhenSmall] = useState(false);
  const [showFuture, setShowFuture] = useState(false);

  return (
    <Control id="weatherContainer" position="bottomleft">
      <div
        id="weatherDayPicker"
        className={showWhenSmall ? "visible" : "hidden"}
        style={{ display: props.display ? "block" : "none" }}
      >
        {/* Knapper til mobile. */}
        <div
          className="toggleButton"
          onClick={() => {
            setShowWhenSmall(true);
            props.setSmallWeather(true);
          }}
        >
          <img
            id="toggleButtonIcon"
            src={arrowRight}
            alt="Toogle open weather"
          />
        </div>
        <div
          className="closeButton"
          onClick={() => {
            setShowWhenSmall(false);
            props.setSmallWeather(false);
          }}
        >
          <img id="closeButtonIcon" alt="Toggle close weather" />
        </div>

        <WeatherDisplay
          futureMode={showFuture}
          weather={props.weather}
          spotName={props.spotName}
          weatherLoading={props.weatherLoading}
        />

        {showFuture && (
          <FutureMonths
            futureSwitch={() => {
              setShowFuture((prev) => !prev);
              props.setFutureMode(false, false);
            }}
            setFutureMode={props.setFutureMode}
            language={props.language}
          />
        )}
        {!showFuture && (
          <PickContainer
            onChange={props.onChangeTime}
            language={props.language}
          />
        )}

        {!showFuture && (
          <div
            className="later modeSwitchButton"
            onClick={() => {
              setShowFuture(true);
              props.setFutureMode(true, moment().month(0));
            }}
          >
            <span>{labels.later[props.language]}</span>
          </div>
        )}
      </div>
    </Control>
  );
};

export default DayPicker;
